"use strict";

exports.__esModule = true;
var _CalendarController = require("./CalendarController");
Object.keys(_CalendarController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarController[key]) return;
  exports[key] = _CalendarController[key];
});